export class CreateBancoRequest{
  public descripcion!:string
}
